/* eslint-disable class-methods-use-this */
import { Mesh, BoxGeometry, PlaneGeometry } from "three";
export class RectangularGeometry {
  constructor() {
    Object.defineProperty(this, "key", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: "rectangular"
    });
  }
  buildFront(physicalSize) {
    return new Mesh(new PlaneGeometry(physicalSize.width, physicalSize.height));
  }
  buildBack(physicalSize) {
    return new Mesh(new PlaneGeometry(physicalSize.width, physicalSize.height));
  }
  buildBody(physicalSize) {
    return new Mesh(new BoxGeometry(physicalSize.width, physicalSize.height, physicalSize.depth));
  }
}